import React from 'react';
import { string, func } from 'prop-types';
import noop from 'lodash/noop';
import Alert from '@active/react-ui/Alert';
import Locale from '@active/react-utils/i18n/Locale';
import { handleKeyboardEvent } from '../../../../../../../../../../../shared/utils/commonUtils';

const ErrorMsg = ({
  message, messageId, type, useAddress, suggestedAddresses = [],
}) => {
  if (!type) {
    return null;
  }
  return (
    <Alert theme="inline" type={type} className="error-message cui-mg-b-20">
      <span id="address-error-message" className='cui-mg-r-10'>
        { messageId ? <Locale id={messageId} /> : message }
      </span>
      {
        (message || !!suggestedAddresses[0]) // ADDRESS_ERROR || ADDRESS_SUGGEST
        && <span
          aria-describedby="address-error-message"
          role="button"
          tabIndex={0}
          onClick={useAddress}
          onKeyDown={handleKeyboardEvent(useAddress, 'Enter')}
          className="link-style">
          <Locale id="checkout.lib.components.text.useItAnyway"/>
        </span>
      }
    </Alert>
  );
};

ErrorMsg.defaultProps = {
  useAddress: noop,
};

ErrorMsg.propTypes = {
  message: string,
  messageId: string,
  type: string,
  useAddress: func,
};

export default ErrorMsg;
